import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-lg text-white" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12 col-md-8 col-lg-6 col-xl-6 p-0" }
const _hoisted_4 = { class: "login-box rounded rounded-0-sm p-3 position-relative bg-primary bg-opacity-75 border-gradient-corner-secondary-1" }
const _hoisted_5 = { class: "position-absolute top-0 end-0 mt-2 me-2" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = ["src", "alt", "onerror"]
const _hoisted_8 = { class: "logo-text" }
const _hoisted_9 = { class: "logo-subtitle text-muted small mt-2 mb-3" }
const _hoisted_10 = { class: "fs-6 text-center border-top border-secondary mt-4 pt-3" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_data_bs_theme = _resolveComponent("data-bs-theme")!
  const _component_TitleDivider = _resolveComponent("TitleDivider")!
  const _component_login_modal = _resolveComponent("login-modal")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", {
    class: "min-vh-100 d-flex align-items-center bg-image-full d-flex align-items-center justify-content-center",
    style: _normalizeStyle(`background-image: url(${_ctx.background})`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_data_bs_theme)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.getLogo,
                alt: _ctx.$t('main.company.name'),
                class: "logo-img col-7 col-md-6",
                onerror: _ctx.onerror
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("main.app")), 1),
              _createVNode(_component_TitleDivider, { class: "my-3" }),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("main.login.app")), 1)
            ]),
            _createVNode(_component_login_modal, { onOnLogin: _ctx.continueUse }, null, 8, ["onOnLogin"]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("a", {
                href: `http://${_ctx.staff_href}/login-staff.html`,
                class: "text-decoration-none text-muted"
              }, null, 8, _hoisted_11), [
                [_directive_t, 'internet.staff']
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mt-1" }, "POWERED BY FILOXENIA", -1))
            ])
          ])
        ])
      ])
    ])
  ], 4))
}